import * as marietta from '../../..';
import { EventDispatcher } from '../../flash/events';
import { SVGSprite } from '../../flash/display';
import { Stage } from '../../model';
import { CONTROL_ACTIONMODE } from '../../Constants';

/**
 * control pickers around items
 */
export default class ControlPicker {
  moveFunc;

  moveEndFunc;

  viewObj;

  x;

  y;

  transformMatrix;

  private enterFrameObj: EventDispatcher;

  private moveMouseEvent: MouseEvent;

  /**
   * コンストラクタ
   */
  constructor(container, id) {
    this.enterFrameObj = new EventDispatcher();

    this.viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    this.viewObj.setAttribute('width', '10');
    this.viewObj.setAttribute('height', '10');
    this.viewObj.setAttribute('x', '-5');
    this.viewObj.setAttribute('y', '-5');
    this.viewObj.setAttribute('stroke', '#3598DC');
    this.viewObj.setAttribute('stroke-width', '1');
    this.viewObj.setAttribute('fill', '#FFFFFF');
    this.viewObj.setAttribute('id', `itemController_${id}`);
    // this.viewObj.setStyle("cursor","move");
    container.appendChild(this.viewObj);

    // アクション
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      this.viewObj.addEventListener('touchstart', this.onMouseDownMe, { passive: false });
    } else {
      this.viewObj.addEventListener('mousedown', this.onMouseDownMe);
    }
    ua = null;
  }

  /**
   * マウスダウンされた
   * @param MouseEvent
   */
  onMouseDownMe = (e: MouseEvent) => {
    // 選択モードのときは、バブリングさせない
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM) {
      e.stopPropagation();
    }

    // ターゲットがドラッグ中でピック出来ないくらい小さい場合は、ドラッグを停止させてあげる。
    if (marietta.webcad.WebCADGlobal.itemManager._currentItem?.isFollowingMouse) {
      marietta.webcad.WebCADGlobal.itemManager._currentItem.stopFollowMouse();
      return;
    }

    // ドラッグの開始
    e.preventDefault();
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      document.addEventListener('touchmove', this.onMouseMoveMe, { passive: false });
      document.addEventListener('touchend', this.onMouseUpMe, { passive: false });
    } else {
      document.addEventListener('mousemove', this.onMouseMoveMe);
      document.addEventListener('mouseup', this.onMouseUpMe);
    }

    const scope: ControlPicker = this;

    // comment k.kubonaka
    // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
    // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
    this.enterFrameObj.onEnterFrame = (): void => {
      if (scope.moveMouseEvent != null) {
        scope.moveFunc(scope.moveMouseEvent, scope);
      }
    };

    ua = null;
  };

  /**
   * マウスが移動した
   */
  onMouseMoveMe = (e: MouseEvent & TouchEvent) => {
    const self: ControlPicker = this;
    e.preventDefault();
    this.moveMouseEvent = e;
    // this.moveFunc( e, this );
    // pad スマホ用タッチ座標修正
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      if (e.touches.length >= 2) {
        // self.deleteMe();
        self.onMouseUpMe(e);
        return;
      }

      e.preventDefault();
      Stage.refreshStageMouse(<any>e);
    }
  };

  /**
   * マウスがUPされた
   */
  onMouseUpMe = (e: MouseEvent) => {
    e.preventDefault();
    this.enterFrameObj.deleteEnterFrame();
    this.moveMouseEvent = null;

    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      document.removeEventListener('touchmove', this.onMouseMoveMe);
      document.removeEventListener('touchend', this.onMouseUpMe);
    } else {
      document.removeEventListener('mousemove', this.onMouseMoveMe);
      document.removeEventListener('mouseup', this.onMouseUpMe);
    }

    // 終了コールバック
    if (this.moveEndFunc !== undefined) {
      this.moveEndFunc(e);
    }

    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  };

  /**
   * 移動 XY
   */
  move(x, y) {
    this.x = x;
    this.y = y;
    this.updateTranslate();
  }

  /**
   * 移動X
   */
  moveX(x) {
    this.x = x;
    this.updateTranslate();
  }

  /**
   * 移動Y
   */
  moveY(y) {
    this.y = y;
    this.updateTranslate();
  }

  /**
   * Translateのアップデート
   */
  updateTranslate() {
    // レイヤーのスケールの分、割ってやる事で見た目のサイズを維持する
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    let sc: number = 1 / root.scaleX;

    // iPad・スマホは掴みやすくする
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      sc *= 2; // 2倍の大きさにする
    }

    this.transformMatrix = `matrix(${sc},0,0,${sc},${this.x},${this.y})`;
    this.viewObj.setAttribute('transform', this.transformMatrix);
  }

  /**
   * アイコンの非表示
   */
  hide() {
    (<HTMLElement> this.viewObj).style.visibility = 'hidden';
  }

  /**
   * アイコンの表示
   */
  show() {
    (<HTMLElement> this.viewObj).style.visibility = 'visible';
  }

  /**
   * ピッカーdiable
   */
  disablePicker() {
    this.viewObj.setAttribute('fill', '#cccccc');
    this.viewObj.setAttribute('stroke', '#FFFFFF');
  }

  /**
   * ピッカーenable
   */
  enablePicker() {
    this.viewObj.setAttribute('fill', '#FFFFFF');
    this.viewObj.setAttribute('stroke', '#3598DC');
  }

  //--------------------------------
  // モバイル用移動軸対応
  originalPosition: marietta.core.Point;

  /**
   * 元位置の保持
   */
  saveOriginalPoisition() {
    this.originalPosition = new marietta.core.Point(this.x, this.y);
  }
}
